<div class="fleet-tracking-container">
    <!-- Header -->
    <div class="fleet-header">
        <div class="d-flex justify-content-between align-items-center mb-4">
            <div>
                <h2 class="mb-1">Seguimiento de Flota</h2>
                <p class="text-muted mb-0">Control visual de movimientos vehiculares</p>
            </div>
            <button *ngIf="userPermissions.canCreateMovements" class="btn btn-primary" (click)="openEntryExitModal()">
                <i class="bi bi-plus-circle me-2"></i>
                Registrar Movimiento
            </button>
        </div>

        <!-- Selector de mes -->
        <div class="month-selector card shadow-sm mb-4">
            <div class="card-body py-3">
                <div class="d-flex justify-content-between align-items-center">
                    <button class="btn btn-outline-secondary" (click)="changeMonth(-1)">
                        <i class="bi bi-chevron-left"></i>
                    </button>

                    <div class="text-center">
                        <h4 class="mb-0">{{ currentMonthName }} {{ currentYear }}</h4>
                        <small class="text-muted">{{ daysInMonth }} días</small>
                    </div>

                    <button class="btn btn-outline-secondary" (click)="changeMonth(1)">
                        <i class="bi bi-chevron-right"></i>
                    </button>
                </div>
            </div>
        </div>

        <!-- Leyenda de estatus -->
        <div class="status-legend card shadow-sm mb-4">
            <div class="card-body py-3">
                <div class="d-flex flex-wrap gap-3">
                    <div *ngFor="let status of statusCatalog" class="legend-item">
                        <span class="status-badge" [style.background-color]="status.color"></span>
                        <span class="ms-2">{{ status.name }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Tablero principal -->
    <div class="fleet-board card shadow-sm">
        <div class="card-body p-0">
            <div class="table-responsive">
                <div class="fleet-grid">
                    <!-- Header de la tabla -->
                    <div class="grid-header">
                        <div class="vehicle-info-header">
                            <div class="header-cell">Placa</div>
                            <div class="header-cell">Marca</div>
                            <div class="header-cell">Modelo</div>
                            <div class="header-cell">Color</div>
                        </div>
                        <div class="days-header-wrapper" #daysHeaderWrapper>
                            <div class="days-header">
                                <div class="day-cell" *ngFor="let day of daysArray" [class.today-header]="isToday(day)">
                                    <div class="day-number">{{ day }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="quick-action-header" *ngIf="userPermissions.canCreateMovements">
                            <span>Acción</span>
                        </div>
                    </div>

                    <!-- Loading -->
                    <div *ngIf="isLoading" class="text-center py-5">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Cargando...</span>
                        </div>
                        <p class="mt-3 text-muted">Cargando tablero...</p>
                    </div>

                    <!-- Contenedor con scroll único -->
                    <div *ngIf="!isLoading" class="grid-body-wrapper" #gridBodyWrapper>
                        <div class="grid-body">
                            <div *ngFor="let vehicle of vehicles" class="vehicle-row">
                                <!-- Información del vehículo -->
                                <div class="vehicle-info">
                                    <div class="info-cell plates-cell">
                                        <strong>{{ vehicle.plates }}</strong>
                                    </div>
                                    <div class="info-cell">{{ vehicle.brand }}</div>
                                    <div class="info-cell">{{ vehicle.model }}</div>
                                    <div class="info-cell">{{ vehicle.color }}</div>
<!--                                    <div class="info-cell">-->
<!--                                        <span class="color-indicator" [style.background-color]="vehicle.color"></span>-->
<!--                                        {{ vehicle.color }}-->
<!--                                    </div>-->
                                </div>

                                <!-- Días del mes -->
                                <!-- Días del mes - REEMPLAZAR esta sección -->
<!--                                <div class="days-grid">-->
<!--                                    <div-->
<!--                                            *ngFor="let day of daysArray"-->
<!--                                            class="day-status-cell"-->
<!--                                            [class.has-multiple]="hasMultipleMovements(vehicle.dailyStatus[day]) && !isFutureDay(day)"-->
<!--                                            [class.future-day]="isFutureDay(day)"-->
<!--                                            [class.today]="isToday(day)"-->
<!--                                            (click)="!isFutureDay(day) && openDayDetails(vehicle, day)">-->

<!--                                        &lt;!&ndash; Mostrar movimiento solo si NO es día futuro &ndash;&gt;-->
<!--                                        <ng-container *ngIf="!isFutureDay(day) && getPrimaryMovement(vehicle.dailyStatus[day]) as movement">-->
<!--                                            <div-->
<!--                                                    class="status-box"-->
<!--                                                    [style.background-color]="movement.statusColor"-->
<!--                                                    [attr.title]="movement.statusName">-->

<!--                                                &lt;!&ndash; Indicador de servicio &ndash;&gt;-->
<!--                                                <div *ngIf="movement.serviceId" class="service-indicator">-->
<!--                                                    OS: {{ movement.serviceId }}-->
<!--                                                </div>-->

<!--                                                &lt;!&ndash; Indicador de múltiples movimientos &ndash;&gt;-->
<!--                                                <div *ngIf="hasMultipleMovements(vehicle.dailyStatus[day])" class="multiple-indicator">-->
<!--                                                    <i class="bi bi-layers-fill"></i>-->
<!--                                                </div>-->

<!--                                                &lt;!&ndash; Badge especial si es HOY y está abierto &ndash;&gt;-->
<!--                                                <div *ngIf="isToday(day) && movement.isOpen" class="active-now-badge">-->
<!--                                                    <i class="bi bi-circle-fill blink"></i>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </ng-container>-->

<!--                                        &lt;!&ndash; Día futuro o sin movimiento &ndash;&gt;-->
<!--                                        <div *ngIf="isFutureDay(day) || !getPrimaryMovement(vehicle.dailyStatus[day])"-->
<!--                                             class="status-box empty"-->
<!--                                             [class.future]="isFutureDay(day)">-->
<!--                                            <span class="text-muted">{{ isFutureDay(day) ? '' : '-' }}</span>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
                                <!-- Días del mes - REEMPLAZAR esta sección -->
                                <div class="days-grid">
                                    <div
                                            *ngFor="let day of daysArray"
                                            class="day-status-cell"
                                            [class.has-multiple]="hasMultipleMovements(vehicle.dailyStatus[day]) && !isFutureDay(day)"
                                            [class.future-day]="isFutureDay(day)"
                                            [class.today]="isToday(day)"
                                            (click)="!isFutureDay(day) && openDayDetails(vehicle, day)">

                                        <!-- Mostrar movimiento solo si NO es día futuro -->
                                        <ng-container *ngIf="!isFutureDay(day) && getPrimaryMovement(vehicle.dailyStatus[day]) as movement">
                                            <div
                                                    class="status-box"
                                                    [style.background-color]="movement.statusColor"
                                                    [attr.title]="movement.statusName">

                                                <!-- Indicador de servicio -->
                                                <div *ngIf="movement.serviceId" class="service-indicator">
                                                    OS: {{ movement.serviceId }}
                                                </div>

                                                <!-- Indicador de múltiples movimientos -->
                                                <div *ngIf="hasMultipleMovements(vehicle.dailyStatus[day])" class="multiple-indicator">
                                                    <i class="bi bi-layers-fill"></i>
                                                </div>

                                                <!-- Badge especial si es HOY y está abierto -->
                                                <div *ngIf="isToday(day) && movement.isOpen" class="active-now-badge">
                                                    <i class="bi bi-circle-fill blink"></i>
                                                </div>
                                            </div>
                                        </ng-container>

                                        <!-- Día futuro o sin movimiento -->
                                        <div *ngIf="isFutureDay(day) || !getPrimaryMovement(vehicle.dailyStatus[day])"
                                             class="status-box empty"
                                             [class.future]="isFutureDay(day)">
                                            <span class="text-muted">{{ isFutureDay(day) ? '' : '-' }}</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Botón de acción rápida -->
                                <div class="quick-action" *ngIf="userPermissions.canCreateMovements">
                                    <button
                                            class="btn btn-sm btn-outline-primary"
                                            (click)="openEntryExitModal(vehicle.vehicleId)"
                                            title="Registrar movimiento">
                                        <i class="bi bi-plus"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Sin datos -->
                    <div *ngIf="!isLoading && vehicles.length === 0" class="text-center py-5">
                        <i class="bi bi-inbox display-1 text-muted"></i>
                        <p class="mt-3 text-muted">No hay vehículos registrados</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal de detalles del día -->
<div class="modal fade" [class.show]="showDetailsModal" [style.display]="showDetailsModal ? 'block' : 'none'" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">
                    Detalles - {{ selectedVehicle?.plates }}
                    <span>| {{ selectedDay }}/{{ currentMonth }}/{{ currentYear }}</span>
                </h5>
                <button type="button" class="btn-close" (click)="closeDetailsModal()"></button>
            </div>
            <div class="modal-body">
                <div class="timeline">
                    <div *ngFor="let movement of selectedDayMovements; let i = index" class="timeline-item">
                        <div class="timeline-marker" [style.background-color]="movement.statusColor"></div>
                        <div class="timeline-content">
                            <div class="d-flex justify-content-between align-items-start mb-2">
                                <div>
                                    <h6 class="mb-1">{{ movement.statusName }}</h6>
                                    <small class="text-muted">
                                        {{ formatTime(movement.startTime) }} - {{ formatTime(movement.endTime) }}
                                        <span class="badge bg-secondary ms-2">{{ movement.duration }}h</span>
                                    </small>
                                </div>
                                <span
                                        class="badge"
                                        [style.background-color]="movement.statusColor">
                  {{ movement.statusCode }}
                </span>
                            </div>

                            <div *ngIf="movement.serviceId" class="alert alert-info mb-2 py-2">
                                <i class="bi bi-file-text me-2"></i>
                                <strong>Orden de Servicio:</strong> #{{ movement.serviceId }}
                            </div>

                            <div *ngIf="movement.comments" class="comments">
                                <i class="bi bi-chat-left-text me-2"></i>
                                <span>{{ movement.comments }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="closeDetailsModal()">
                    Cerrar
                </button>
            </div>
        </div>
    </div>
</div>
<div class="modal-backdrop fade" [class.show]="showDetailsModal" *ngIf="showDetailsModal"></div>

<!-- Modal de entrada/salida -->
<div class="modal fade" [class.show]="showEntryExitModal" [style.display]="showEntryExitModal ? 'block' : 'none'" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">
                    <i class="bi bi-arrow-left-right me-2"></i>
                    Registrar Movimiento
                </h5>
                <button type="button" class="btn-close" (click)="closeEntryExitModal()"></button>
            </div>
            <div class="modal-body">
                <form>
                    <!-- Vehículo -->
                    <div class="mb-3">
                        <label class="form-label">Vehículo *</label>
                        <select class="form-select" [(ngModel)]="movementForm.vehicleId" name="vehicleId" required>
                            <option [value]="0">Seleccionar vehículo</option>
                            <option *ngFor="let vehicle of vehicles" [value]="vehicle.vehicleId">
                                {{ vehicle.plates }} - {{ vehicle.color }}
                            </option>
                        </select>
                    </div>

                    <!-- Estatus principal -->
                    <div class="mb-3">
                        <label class="form-label">Estatus *</label>
                        <select class="form-select" [(ngModel)]="movementForm.statusId" name="statusId" required>
                            <option [value]="0">Seleccionar estatus</option>
                            <optgroup *ngFor="let status of statusCatalog" [label]="status.name">
                                <option [value]="status.id">{{ status.name }}</option>
                                <option *ngFor="let sub of status.subcategories" [value]="sub.id">
                                    └─ {{ sub.name }}
                                </option>
                            </optgroup>
                        </select>
                    </div>

                    <!-- Servicio (opcional) -->
                    <div class="mb-3">
                        <label class="form-label">ID de Servicio (opcional)</label>
                        <input
                                type="number"
                                class="form-control"
                                [(ngModel)]="movementForm.serviceId"
                                name="serviceId"
                                placeholder="Ej: 3492">
                    </div>

                    <!-- Fecha y hora -->
                    <div class="mb-3">
                        <label class="form-label">Fecha y Hora de Inicio *</label>
                        <input
                                type="datetime-local"
                                class="form-control"
                                [(ngModel)]="movementForm.startDate"
                                name="startDate"
                                required>
                    </div>

                    <!-- Comentarios -->
                    <div class="mb-3">
                        <label class="form-label">Comentarios</label>
                        <textarea
                                class="form-control"
                                rows="3"
                                [(ngModel)]="movementForm.comments"
                                name="comments"
                                placeholder="Detalles adicionales del movimiento..."></textarea>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="closeEntryExitModal()">
                    Cancelar
                </button>
                <button type="button" class="btn btn-primary" (click)="saveMovement()">
                    <i class="bi bi-save me-2"></i>
                    Guardar Movimiento
                </button>
            </div>
        </div>
    </div>
</div>
<div class="modal-backdrop fade" [class.show]="showEntryExitModal" *ngIf="showEntryExitModal"></div>
